/**
 * 共通のスクロール表示
 */

import ResizeWatch from '../utils/ResizeWatch';
import ScrollWatch from '../utils/ScrollWatch';
import AnyStore from '../common/AnyStore';
import PageTransition from '../common/PageTransition';

export default class commonShowEntry {
  /**
   * コンストラクタ
   */
  constructor() {
    // クラス名
    this.name = 'commonShowEntry';
    this.isStart = false;
    this.openObject = [];
    this.scrollObject = [];

    this.init();
  }

  /**
   * 表示前
   */
  init() {
    this.PageTransition = new PageTransition();

    // はじめに表示
    const elView = document.querySelectorAll('.p-opening-view');
    if (elView.length > 0) {
      elView.forEach((el, i) => {
        TweenMax.set(el, {className: '+=is-hide'});
        this.openObject.push({
          el: el,
          delay: 0,
          isShow: false
        });
      });
    }

    // スクロールで表示
    // 下の次へリンク
    const elScroll = document.querySelectorAll('.p-scroll-view');
    if (elScroll.length > 0) {
      elScroll.forEach((el, i) => {
        TweenMax.set(el, {className: '+=is-hide'});
        this.scrollObject.push({
          el: el,
          delay: 0,
          isShow: false
        });
      });
    }

    // domの最大数
    this.max = this.scrollObject.length;

    // トランジション時のコールバック
    // start
    this.PageTransition.on('TRANSITION_OUT',  this.transitionOut.bind(this));
    // next
    this.PageTransition.on('TRANSITION_IN', this.transitionIn.bind(this));

    // イベント
    this.resizeUpdate();
    ResizeWatch.registerObserver(this.name, this);
    ScrollWatch.registerObserver(this.name, this);
  }

  /**
   * 表示時
   */
  start() {
    // 前面のレイヤーを上に移動する
    this.PageTransition.transitionOut();
  }

  /**
   * 表示アニメ
   */
  transitionOut() {
    this.count = 0;
    this.delay = 0;
    this.ref = null;

    if (this.openObject.length > 0) {
      requestAnimationFrame(this.delayAnim.bind(this));
    } else {
      this.transitionOutComp();
    }
  }

  /**
   * ずらして実行
   */
  delayAnim() {
    this.delay = 0.1 * this.count;
    this.ref = this.openObject[this.count];

    this.ref.isShow = true;
    TweenMax.set(this.ref.el, {transitionDelay: (0.2 + this.delay) + 's, ' + (0.1 + this.delay) + 's'});
    TweenMax.set(this.ref.el, {className: '-=is-hide'});

    this.count++;

    if (this.count < this.openObject.length) {
      requestAnimationFrame(this.delayAnim.bind(this));
    } else {
      this.transitionOutComp();
    }
  }

  transitionOutComp() {
    this.isStart = true;
    this.resizeUpdate();
  }

  /**
   * 非表示時アニメ
   */
  transitionIn() {

  }

  /**
   * スクロール
   */
  scrollUpdate(_scrollY) {
    if (!this.isStart) return;

    let isFinish = true;
    const posY = _scrollY + (window.innerHeight * 0.75);

    for (let i = 0; i < this.max; i++) {
      if (this.scrollObject[i].isShow) continue;

      isFinish = false;
      if (posY > AnyStore.getOffsetTop(this.scrollObject[i].el).top) {
        this.scrollObject[i].isShow = true;
        TweenMax.set(this.scrollObject[i].el, {
          className: '-=is-hide'
        });

        // 表示済みなので削除
        this.scrollObject.splice(i, 1);
        this.max = this.scrollObject.length;
        i--;
      }
    }

    if (isFinish) {
      // 全部表示した
      this.destroy();
    }
  }

  /**
   * リサイズ
   */
  resizeUpdate() {
    this.scrollUpdate(AnyStore.getScrollTop());
  }

  /**
   * 削除
   */
  destroy() {
    this.openObject = [];
    this.scrollObject = [];
    ResizeWatch.cancelObserver(this.name);
    ScrollWatch.cancelObserver(this.name);
  }
}
